import { useCallback } from 'react';
import { CareerId } from '@common/const/catalog/career';
import { ClientType } from '@common/model/client/clientType';
import { useLoginOrRegistration } from 'src/features/auth';

export const useSpecialistRegistrationCareer = () => {
  const loginOrRegistration = useLoginOrRegistration();

  return useCallback(
    (careerId: CareerId) => {
      loginOrRegistration({ clientSelection: { careerId, clientType: ClientType.Specialist } });
    },
    [loginOrRegistration],
  );
};
